import React from "react";
import { isArray } from "lodash";
import convertTry from "./convertTry";

const capitalizeFirstLetter = (item) => {
  if (item) return item.charAt(0).toUpperCase() + item.slice(1).toLowerCase();
};

const slugify = (text) => {
  var trMap = {
    çÇ: "c",
    ğĞ: "g",
    şŞ: "s",
    üÜ: "u",
    ıİ: "i",
    öÖ: "o"
  };
  for (var key in trMap) {
    text = text.replace(new RegExp("[" + key + "]", "g"), trMap[key]);
  }
  return text
    .replace(/[^-a-zA-Z0-9\s]+/gi, "") // remove non-alphanumeric chars
    .replace(/\s/gi, "-") // convert spaces to dashes
    .replace(/[-]+/gi, "-") // trim repeated dashes
    .toLowerCase();
};

const turkishToUpperCase = (string) => {
  var letters = { i: "İ", ş: "Ş", ğ: "Ğ", ü: "Ü", ö: "Ö", ç: "Ç", ı: "I" };
  string = string?.replace(/(([iışğüçö]))/g, function (letter) {
    return letters[letter];
  });
  return string?.toUpperCase();
};

function replaceRange(s, start, end, substitute) {
  return s?.substring(0, start) + substitute + s?.substring(end);
}

const querystring = (obj) => {
  const str = [];
  for (var p in obj)
    if (obj.hasOwnProperty(p)) {
      str.push(encodeURIComponent(p) + "=" + encodeURIComponent(obj[p]));
    }
  return str.join("&");
};

const convertNumberToString = (sayi) => {
  const totalSayi = sayi;
  const tempTamsayi = toString(sayi).split(".")[0];
  const tempOndalik = toString(sayi).split(".")[1] || "";
  let rakam = tempTamsayi.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ".");
  let tamsayi = toString(rakam);
  let ondalik = toString(tempOndalik || "");

  var birler = ["", "Bir", "İki", "Üç", "Dört", "Beş", "Altı", "Yedi", "Sekiz", "Dokuz"];
  var onlar = ["", "On", "Yirmi", "Otuz", "Kırk", "Elli", "Altmış", "Yetmiş", "Seksen", "Doksan"];
  var binler = ["", "Bin", "Milyon", "Milyar", "Trilyon", "Katrilyon", "Kentilyon"];
  var sonuc = [];

  var adim = 0;
  for (let i = tamsayi.split(".").length; i > 0; i--) {
    sayi = tamsayi.split(".")[i - 1];
    if (sayi.length === 1) {
      sayi = "00" + sayi;
    }
    if (sayi.length === 2) {
      sayi = "0" + sayi;
    }
    let c = "";

    for (let j = 1; j < sayi.length + 1; j++) {
      if (j === 1 && sayi[j - 1] === 1) {
        c += " Yüz ";
      } else if (j === 1 && birler[sayi[j - 1]] !== "") {
        c += (birler[sayi[j - 1]] === "Bir" ? "" : birler[sayi[j - 1]]) + " Yüz ";
      } else if (j === 2) {
        c += onlar[sayi[j - 1]] + " ";
      } else if (j === 3 && tamsayi.length === 5 && sayi[j - 1] === 1 && adim === 1) {
        c += " ";
      } else if (j === 3) {
        c += birler[sayi[j - 1]] + " ";
      }
    }

    if (c !== "") {
      if (c === " Bir " && binler[adim] === "Bin") {
        c = "";
      }
      sonuc.push(c + binler[adim]);
    }
    adim++;
  }

  if (sonuc.length !== 0) {
    sonuc = sonuc.reverse().join(" ") + "TL";
  } else {
    sonuc = "";
  }
  if (ondalik.length === 1) {
    ondalik = ondalik + "0";
  }
  if (ondalik !== "") {
    sonuc += " ," + onlar[ondalik?.[0]] + " " + birler[ondalik[1]] + " Kuruş";
  }

  sonuc = sonuc.replace(/  +/g, " ");

  return `Yalnız ${convertTry(totalSayi)} (${sonuc || ""}) Tahsil Edilmiştir.`;
};

function numberWithCommas(x) {
  return x ? x.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ".") : x;
}

function phoneNumberMask(phoneNumberList) {
  if (isArray(phoneNumberList)) {
    return phoneNumberList?.map((phone) => {
      const invalidCharacters = ["9", "90", "90", "0"];
      let maskedPhone = phone?.replace(/[^0-9]/g, "");

      invalidCharacters.forEach((character) => {
        if (maskedPhone?.startsWith(character)) {
          maskedPhone = maskedPhone.replace(character, "");
        }
      });
      return maskedPhone;
    });
  } else {
    return [];
  }
}

const convertPhoneNumberForWhatsapp = (value) => {
  //gelen parametredeki boşlukları silip parametreyi string olarak döndürür.
  if (isArray(value) && value.length > 0) {
    const search = " ";
    const result = value?.[0]?.split(search).join("");
    return result;
  } else {
    return "";
  }
};

function truncate(str, n) {
  return str.length > n ? str.slice(0, n - 1) + "..." : str;
}

const hourFormatter = (min) => {
  var sec_num = parseInt(min, 10); // don't forget the second param
  var hours = Math.floor(sec_num / 3600);
  var minutes = Math.floor((sec_num - hours * 3600) / 60);
  var seconds = sec_num - hours * 3600 - minutes * 60;

  if (hours < 10) {
    hours = "0" + hours;
  }
  if (minutes < 10) {
    minutes = "0" + minutes;
  }
  if (seconds < 10) {
    seconds = "0" + seconds;
  }
  return hours + ":" + minutes + ":" + seconds;
};

const Linkify = ({ text }) => {
  const linkifyText = (text) => {
    const urlRegex = /(\bhttps?:\/\/[-A-Z0-9+&@#/%?=~_|!:,.;]*[-A-Z0-9+&@#/%=~_|])/gi;
    return text.split(urlRegex).map((part, index) =>
      urlRegex.test(part) ? (
        <a key={index} href={part} target="_blank" rel="noopener noreferrer">
          {part}
        </a>
      ) : (
        part
      )
    );
  };

  return <div>{linkifyText(text)}</div>;
};

const LivexamyLinkify = ({ text, color = null }) => {
  const linkifyText = (text) => {
    const urlRegex = /(\bhttps?:\/\/[-A-Z0-9+&@#/%?=~_|!:,.;]*[-A-Z0-9+&@#/%=~_|])/gi;
    return text.split(urlRegex).map((part, index) =>
      urlRegex.test(part) ? (
        <a
          style={{
            wordBreak: "break-all",
            color: color || "inherit"
          }}
          key={index}
          href={part}
          target="_blank"
          rel="noopener noreferrer"
        >
          {part}
        </a>
      ) : (
        <span key={index} style={{ color: color || "inherit" }}>
          {part}
        </span>
      )
    );
  };

  return (
    <div className="w-100" style={{ color: color || "inherit" }}>
      {linkifyText(text)}
    </div>
  );
};

function minFormatter(second) {
  if (isNaN(second)) return "--:--";
  const min = Math.floor(second / 60);
  const sec = second % 60;
  const _min = min.toString().padStart(2, "0");
  const _sec = sec.toString().padStart(2, "0");

  return `${_min}:${_sec}`;
}

const validateTC = (tc) => {
  if (!/^\d{11}$/.test(tc)) return "TC Kimlik Numarası 11 haneli olmalıdır.";
  const digits = tc.split("").map(Number);
  let [oddSum, evenSum] = [0, 0];

  for (let i = 0; i < 9; i++) {
    if (i % 2 === 0) oddSum += digits[i];
    else evenSum += digits[i];
  }

  const tenthDigit = (((oddSum * 7 - evenSum) % 10) + 10) % 10;
  const eleventhDigit = digits.slice(0, 10).reduce((acc, val) => acc + val, 0) % 10;

  if (digits[0] === 0) return "TC Kimlik Numarası 0 ile başlayamaz.";
  if (digits[9] !== tenthDigit) return "TC Kimlik Numarası geçersiz.";
  if (digits[10] !== eleventhDigit) return "TC Kimlik Numarası geçersiz.";

  return undefined; // Geçerli
};

function validatePhoneNumber(phone) {
  if (!phone) return "Telefon numarası boş olamaz.";

  if (!/^[\d\s+()-]+$/.test(phone))
    return "Telefon numarası yalnızca rakam, +, -, ( ) ve boşluk içerebilir.";

  const regex = /^(?:\+90|0)?5\d{9}$/;
  if (!regex.test(phone))
    return "Telefon numarası geçerli bir formatta olmalıdır (örn: +905551234567 veya 05551234567).";

  return undefined;
}

const validateEmail = (email) => {
  if (!email) return undefined; // Eğer e-posta boşsa doğrulama yapma
  const emailRegex = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;
  if (!emailRegex.test(email)) return "Geçerli bir e-posta adresi giriniz.";
  return undefined; // Geçerli
};
const validatePhone = (phone) => {
  if (!phone) {
    return "Cep telefonu zorunludur.";
  }
  return undefined;
};

const millisToTimeString = (millis = 0, showText = false) => {
  const timeFormatter = (t) => (t > 9 ? t : "0" + t);
  const ms = millis % 1000;
  millis = (millis - ms) / 1000;
  const secs = millis % 60;
  millis = (millis - secs) / 60;
  const mins = millis % 60;
  const hrs = (millis - mins) / 60;
  if (showText) {
    if (hrs > 0)
      return (
        timeFormatter(hrs) +
        " Saat " +
        timeFormatter(mins) +
        " Dakika " +
        timeFormatter(secs) +
        " Saniye"
      );
    else if (mins > 0) return timeFormatter(mins) + " Dakika " + timeFormatter(secs) + " Saniye";
    else return timeFormatter(secs) + " Saniye";
  } else {
    if (hrs > 0) return timeFormatter(hrs) + ":" + timeFormatter(mins) + ":" + timeFormatter(secs);
    else return timeFormatter(mins) + ":" + timeFormatter(secs);
  }
};

const dateConvertToAwsCron = (date) => {
  const utcMinutes = date.getUTCMinutes();
  const utcHours = date.getUTCHours();
  const utcDay = date.getUTCDate();
  const utcMonth = date.getUTCMonth() + 1; // Aylar 0'dan başlar
  const utcYear = date.getUTCFullYear();

  return `cron(${utcMinutes} ${utcHours} ${utcDay} ${utcMonth} ? ${utcYear})`;
};

const parseAwsCron = (cronExpression) => {
  const months = [
    "Ocak",
    "Şubat",
    "Mart",
    "Nisan",
    "Mayıs",
    "Haziran",
    "Temmuz",
    "Ağustos",
    "Eylül",
    "Ekim",
    "Kasım",
    "Aralık"
  ];

  const match = cronExpression.match(/^cron\((\S+) (\S+) (\S+) (\S+) (\S+) (\S+)\)$/);
  if (!match) return "Geçersiz cron ifadesi";

  let [, minute, hour, day, month, , year] = match;

  // Sayısal değerleri dönüştür
  let newMinute = parseInt(minute, 10);
  let newHour = parseInt(hour, 10) + 3; // 3 saat ekleme

  // Gün içinde kalması için saat düzenlemesi
  if (newHour >= 24) {
    newHour -= 24;
    if (day !== "*") {
      day = (parseInt(day, 10) + 1).toString();
    }
  }

  const formattedMinute = newMinute.toString().padStart(2, "0");
  const formattedHour = newHour.toString().padStart(2, "0");
  const formattedDay = day === "*" ? "her gün" : `${day} `;
  const formattedMonth = month === "*" ? "her ay" : months[parseInt(month) - 1];
  const formattedYear = year === "*" ? "her yıl" : year;

  if (day !== "*" && month !== "*") {
    return `${formattedDay} ${formattedMonth} ${formattedYear} tarihinde saat ${formattedHour}:${formattedMinute}'de çalışacak.`;
  } else if (day === "*" && month === "*" && year === "*") {
    return `Her gün saat ${formattedHour}:${formattedMinute}'de çalışacak.`;
  } else if (day === "*" && month !== "*" && year !== "*") {
    return `${formattedMonth} ayında her gün saat ${formattedHour}:${formattedMinute}'de çalışacak.`;
  } else {
    return `Belirtilmemiş bir zaman formatı: ${cronExpression}`;
  }
};

function getFirstLastInitials(fullName) {
  const nameParts = fullName.split(" ");
  const firstInitial = nameParts[0].charAt(0);
  const lastInitial = nameParts[nameParts.length - 1].charAt(0);
  return firstInitial + lastInitial;
}

function isValidTurkishIBAN(iban) {
  iban = iban?.replace(/\s+/g, "").toUpperCase();
  if (!iban?.startsWith("TR") || iban?.length !== 26) {
    return false;
  }
  if (!/^[A-Z0-9]+$/.test(iban)) {
    return false;
  }
  let rearranged = iban?.slice(4) + iban?.slice(0, 4);
  let numericIban = "";
  for (let char of rearranged) {
    if (/[A-Z]/.test(char)) {
      numericIban += (char.charCodeAt(0) - 55).toString(); // A=65 ASCII → 10
    } else {
      numericIban += char;
    }
  }
  let remainder = numericIban;
  let block;
  let mod = 0;
  while (remainder.length > 0) {
    block = mod + remainder.substring(0, 9);
    remainder = remainder.substring(9);
    mod = parseInt(block, 10) % 97;
  }
  return mod === 1;
}

const LEVEL_FILTER_ALTERNATIVES = {
  "12, m": ["12", "mezun"],
  "12,m": ["12", "mezun"],
  "12-m": ["12", "mezun"],
  "m, 12": ["12", "mezun"],
  "m,12": ["12", "mezun"],
  "m-12": ["12", "mezun"],
  "12m": ["12", "mezun"],
  m12: ["12", "mezun"]
};

const trCollator = new Intl.Collator("tr", { sensitivity: "base" });
const comparatorText = (a = "", b = "") => trCollator.compare(a.trimStart(), b.trimStart());

const textCustomComparator = (_filter, value, filterText) => {
  const normalizedValue = (value || "").toString().toLowerCase();
  const normalizedFilter = (filterText || "").toLowerCase().trim();
  if (!normalizedFilter) return true;
  const alternatives = LEVEL_FILTER_ALTERNATIVES[normalizedFilter] || [normalizedFilter];
  return alternatives.some((keyword) => normalizedValue.includes(keyword));
};

export {
  capitalizeFirstLetter,
  turkishToUpperCase,
  replaceRange,
  slugify,
  querystring,
  convertNumberToString,
  numberWithCommas,
  phoneNumberMask,
  convertPhoneNumberForWhatsapp,
  truncate,
  hourFormatter,
  Linkify,
  minFormatter,
  validateTC,
  validateEmail,
  validatePhone,
  millisToTimeString,
  dateConvertToAwsCron,
  parseAwsCron,
  validatePhoneNumber,
  getFirstLastInitials,
  isValidTurkishIBAN,
  LivexamyLinkify,
  comparatorText,
  textCustomComparator
};
